// src/campaigns/hooks/useCampaignMeta.ts

import { useMemo } from "react";
import { DEFAULT_CAMPAIGN_OG } from "../constants/campaign-og";
import { getAbsoluteCampaignImageUrl } from "../engine/campaign-helpers";
import { useCampaign } from "../providers/CampaignProvider";

export function useCampaignMeta() {
  const { activeCampaign } = useCampaign();

  return useMemo(() => {
    const og = activeCampaign?.og || DEFAULT_CAMPAIGN_OG;

    return {
      title: og.title,
      description: og.description,
      imageUrl: getAbsoluteCampaignImageUrl(og.imagePath),
      themeColor: activeCampaign?.theme.primary || "#ff6b6b",
      activeCampaign,
    };
  }, [activeCampaign]);
}
